'use strict';

class RecipientLedger {
  constructor($filter, $routeParams, recipientService, salesLedgerService) {
    this.$filter = $filter;
    this.recipientService = recipientService;
    this.salesLedgerService = salesLedgerService;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.balance = 0;
    this.recipient = {};
    this.entries = [];

    this.load();
  }

  load() {
    this.recipientService.get(this.number)
      .then((resp) => {
        this.recipient = resp.data;
      });

    this.salesLedgerService.getRecipient(this.number)
      .then((resp) => {
        let runningBalance = 0;

        resp.data.forEach((entry) => {
          runningBalance += entry.amount;
          entry.balance = runningBalance;
          return entry;
        });

        return resp.data;
      })
      .then((entries) => {
        this.entries = entries;

        entries.forEach((entry) => {
          this.balance += entry.amount;
        }, this);
      });
  }

  export() {
    this.salesLedgerService.download({
      format: 'XLS',
      recipientNumber: this.number
    });
  }
}

RecipientLedger.$inject = ['$filter', '$routeParams', 'recipientService', 'salesLedgerService'];

const recipientLedger = {
  controller: RecipientLedger,
  template: `
    <div class="row">
      <div class="large-7 columns">
        <h2>Kontooversikt</h2>
        <h3 class="subheader">{{ $ctrl.recipient.name }}</h3>
      </div>
      <div class="large-5 columns right-align">
        <a role="button" class="button secondary" href ng-click="$ctrl.export()"><i class="fa fa-file-excel-o"></i> Eksporter til Excel</a>
        <a role="button" class="button secondary" href="#/kunde/{{ $ctrl.number }}">Tilbake</a>
        <p>Saldo: <b>{{ $ctrl.balance | crowns }}</b></p>
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Dato</th>
          <th>Type</th>
          <th>Fakturanummer</th>
          <th class="right-align nowrap">Debet</th>
          <th class="right-align nowrap">Kredit</th>
          <th class="right-align nowrap">Saldo</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="entry in $ctrl.entries track by $id(entry.number)">
          <td>{{ entry.date | dateFormat }}</td>
          <td>{{ entry.description }}</td>
          <td>
            <a ng-if="entry._links.invoice && !entry._links.creditNote && !entry._links.dunning" href="#/regning/{{ entry._links.invoice.uri | urlParser:1 }}">{{ entry._links.invoice.uri | urlParser:1 }}</a>
            <a ng-if="entry._links.creditNote" href="#/kreditnota/{{ entry._links.creditNote.uri | urlParser:2 }}">{{ entry._links.creditNote.uri | urlParser:2 }}</a>
            <a ng-if="entry._links.dunning" href="#/purring/{{ entry._links.dunning.uri | urlParser:1 }}">{{ entry._links.invoice.uri | urlParser:1 }}</a>
          </td>
          <td class="right-align nowrap">
            <span ng-if="entry.amount > 0">{{ entry.amount | crowns }}</span>
          </td>
          <td class="right-align nowrap">
            <span ng-if="entry.amount < 0">{{ entry.amount * -1 | crowns }}</span>
          </td>
          <td class="right-align nowrap">
            {{ entry.balance | crowns }}
          </td>
        </tr>
      </tbody>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('recipientLedger', recipientLedger)
  .config(($routeProvider) => {
    $routeProvider
      .when('/kunde/:number/oversikt', {
        title: 'Kontooversikt',
        template: '<recipient-ledger />',
        secure: true
      });
  });
